import { initializeApp } from 'firebase/app';
import "firebase/firestore";
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, setPersistence, browserLocalPersistence  } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/storage'; 
import { getStorage } from 'firebase/storage';


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // priests
  // apiKey: "AIzaSyAFdqQBbAu7txhrLDFR--xipAGqplQ-NlU",
  // authDomain: "priest-58289.firebaseapp.com",
  // projectId: "priest-58289",
  // storageBucket: "priest-58289.firebasestorage.app",
  // messagingSenderId: "857987997374",
  // appId: "1:857987997374:web:20ff87b5a18fa1a81bc8ef"
// energyvoo
  apiKey: "AIzaSyCYL4jdQ4luRJuwBSHVqfBuJV4J7Pt_UcU",
    authDomain: "energyvoo.firebaseapp.com",
    projectId: "energyvoo",
    storageBucket: "energyvoo.appspot.com",
    messagingSenderId: "459716366735",
    appId: "1:459716366735:web:c167d67922ab6990b67bfa",
    measurementId: "G-HWNDGWFXZH"

  // new priest
  // apiKey: "AIzaSyCqymffGKbK91ZQ1310_pLi9wmdmDYbYDo",
  // authDomain: "priests-39af3.firebaseapp.com",
  // projectId: "priests-39af3",
  // storageBucket: "priests-39af3.firebasestorage.app",
  // messagingSenderId: "289899844620",
  // appId: "1:289899844620:web:205890c6f1a152d7b6ca29",
  // measurementId: "G-VS9DBLX7DS"
};


firebase.initializeApp(firebaseConfig)


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

//  Ensure auth state is persistent
setPersistence(auth, browserLocalPersistence);

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error("Google Sign-in Error", error);
    return null;
  }
};

export { auth };
export { provider, signInWithPopup, onAuthStateChanged };
export const firestore = getFirestore(app)
export const authentication = getAuth(app);
export const storage = getStorage(app);
